/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ListPtTariffResponse as AgentApiContractListPtTariffResponse } from '../../models/AgentApi/Contract/list-pt-tariff-response';

export interface ApiAgentListPtTariffGet$Plain$Params {

/**
 * * Interface language
 */
  lang?: string;

/**
 * * terminal id
 */
  termCode?: string;
}

export function apiAgentListPtTariffGet$Plain(http: HttpClient, rootUrl: string, params?: ApiAgentListPtTariffGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractListPtTariffResponse>>> {
  const rb = new RequestBuilder(rootUrl, apiAgentListPtTariffGet$Plain.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('termCode', params.termCode, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AgentApiContractListPtTariffResponse>>;
    })
  );
}

apiAgentListPtTariffGet$Plain.PATH = '/api/Agent/ListPtTariff';
